export default __webpack_public_path__ + "static/media/uploader-cross.42be3d0c.svg";